import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { DashboardProvider } from './Context/DashboardContext';
import { useDashboardManagerContext } from './Context/DashboardManagerContext';
import DashboardContent from './DashboardContent';
import { useDarkMode } from '../../hooks/useDarkMode';

export default function DashboardHome() {
    const theme = useTheme();
    const { customColorPalette: palette } = theme;
    const isDarkMode = useDarkMode();
    const { activeDashboardId, isLoading } = useDashboardManagerContext();

    if (isLoading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    gap: 2,
                }}
            >
                <CircularProgress size={40} />
                <Typography
                    sx={{
                        color: isDarkMode ? palette.gray[400] : palette.gray[600],
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                    }}
                >
                    Loading your dashboard...
                </Typography>
            </Box>
        );
    }

    if (!activeDashboardId) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    gap: 2,
                }}
            >
                <Typography
                    sx={{
                        color: isDarkMode ? palette.gray[400] : palette.gray[600],
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                    }}
                >
                    No dashboard found. Please create one.
                </Typography>
            </Box>
        );
    }

    return (
        <DashboardProvider key={activeDashboardId} dashboardId={activeDashboardId}>
            <DashboardContent />
        </DashboardProvider>
    );
}
